export default "<h1>403</h1>\r\n<h2>Forbidden</h2>\r\n<p>This page can't be access.</p>";